import { DialogContent } from '../../../../components/ui/dialog'
import { FormProvider } from 'react-hook-form'
import Header from './components/header'
import PersonalInfoForm from './components/PersonalInfoForm'
import AddressForm from './components/AddressForm'
import BankInfoForm from './components/BankInfoForm'
import ReviewProposal from './components/ReviewProporsal'
import SentProposal from './components/SentProposal'
import Steps from './components/Steps'
import useNewWithdrawModal from './useNewWithdrawModal'
import { Table } from '@/app/services/transactionService/getAvailableCredit'
import { ConfirmationTransactionModal } from './components/ConfirmationTransactionModal'

export default function NewWithdrawModal({ table }: { table: Table | null }) {
  const {
    steps,
    submitForm,
    title,
    form,
    step,
    clientName,
    isSubmitting,
    isOpenConfirmModal,
    setIsOpenConfirmModal,
    pin,
    setPin,
    handleOpenConfirmation,
    user,
  } = useNewWithdrawModal(table)

  const tableValue = table?.amount ? table.amount / 100 : table?.ValorLiquidoCliente

  return (
    <DialogContent className={step < 3 ? 'min-w-[896px] max-sm:min-w-0 max-sm:w-[95vw] max-sm:max-w-none max-md:min-w-0 max-md:w-[90vw] max-md:max-w-none max-sm:max-h-[90vh] max-sm:overflow-y-auto max-md:max-h-[85vh] max-md:overflow-y-auto' : 'min-w-[760px] max-sm:min-w-0 max-sm:w-[95vw] max-sm:max-w-none max-md:min-w-0 max-md:w-[90vw] max-md:max-w-none max-sm:max-h-[90vh] max-sm:overflow-y-auto max-md:max-h-[85vh] max-md:overflow-y-auto'}>
      <div className={step < 4 ? '' : 'hidden'}>
        <Header title={title[step]} />
        <Steps visible={step < 3} />
        <form {...form}>
          <FormProvider {...form}>
            <PersonalInfoForm visible={steps.personalInfo} />
            <AddressForm visible={steps.address} />
            <BankInfoForm visible={steps.bankInfo} />
            <ReviewProposal
              visible={steps.review}
              value={tableValue}
              isSubmitting={isSubmitting}
              handleOpenConfirmation={handleOpenConfirmation}
            />
            <ConfirmationTransactionModal
              clientName={clientName}
              isOpen={isOpenConfirmModal}
              onClose={setIsOpenConfirmModal}
              pin={pin}
              setPin={setPin}
              submitForm={submitForm}
              user={user}
            />
          </FormProvider>
        </form>
      </div>
      <SentProposal
        visible={steps.sentProposal}
        client={clientName}
        value={tableValue}
      />
    </DialogContent>
  )
}
